// extracted by mini-css-extract-plugin
export var danger = "_3r-6";
export var lightPink = "_3r-a";
export var medium = "_3r-j";
export var nearSquare = "_3r-m";
export var neutralBlue = "_3r-8";
export var neutralYellow = "_3r-7";
export var noCapitalize = "_3r-1";
export var normal = "_3r-2";
export var pill = "_3r-0";
export var primary = "_3r-3";
export var primaryLight = "_3r-4";
export var shadow = "_3r-n";
export var small = "_3r-k";
export var solidBlack = "_3r-i";
export var solidGreen = "_3r-d";
export var solidLightBlue = "_3r-f";
export var solidNavy = "_3r-e";
export var solidOrange = "_3r-h";
export var solidPink = "_3r-g";
export var solidRed = "_3r-b";
export var solidWhite = "_3r-9";
export var solidYellow = "_3r-c";
export var success = "_3r-5";
export var xsmall = "_3r-l";